const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "okb-okb-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Path-raw"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 106,
    cy: 48,
    r: 48,
    style: {
      fill: "#88bdf3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 106,
    cy: 164,
    r: 48,
    style: {
      fill: "#3075ee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 164,
    cy: 106,
    r: 48,
    style: {
      fill: "#5795f1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 48,
    cy: 106,
    r: 48,
    style: {
      fill: "#205fec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M94.7,94.7A48,48,0,0,1,59.4,59.4,48.31,48.31,0,0,1,94.7,94.7Z",
    style: {
      fill: "#134bef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M59.3,152.7a48,48,0,0,1,35.3-35.3A48.31,48.31,0,0,1,59.3,152.7Z",
    style: {
      fill: "#0932e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-3",
    "data-name": "Combined-Shape",
    d: "M117.3,117.3a48,48,0,0,1,35.3,35.3A48.31,48.31,0,0,1,117.3,117.3Z",
    style: {
      fill: "#164bea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-4",
    "data-name": "Combined-Shape",
    d: "M152.7,59.3a48,48,0,0,1-35.3,35.3A48.31,48.31,0,0,1,152.7,59.3Z",
    style: {
      fill: "#3170f1"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkb);
export default __webpack_public_path__ + "static/media/okb.14d828ddbe2debae005d6501f36d8884.svg";
export { ForwardRef as ReactComponent };